import ApexCharts from "apexcharts"
import React, { useEffect, useRef, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import DateRangePicker from "react-bootstrap-daterangepicker"
import "bootstrap-daterangepicker/daterangepicker.css"
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger } from "react-bootstrap";
import { LabelList, BarChart, Area, AreaChart, Bar, Tooltip, LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, PieChart, Pie, Cell, } from 'recharts';
import RejectionAlert from "./RejectionAlert"

const CustomerDashboardPage = ({ CustomerProfileData }) => {
    const PricingData = [
        { name: 'InProcess', value: 450 },
        { name: 'Sent', value: 250 },
        { name: 'Requested', value: 400 },
    ];

    const selectedsecondGraphData = [
        { name: 'New', value: 100 },
        { name: 'Picked', value: 90 },
        { name: 'Send for pricing', value: 80 },
        { name: 'Price Received', value: 60 },
        { name: 'Price View', value: 80 },
        { name: 'Quotation Sent', value: 50 },
        { name: 'Converted', value: 70 },
        { name: 'Not Converted', value: 60 },
        { name: 'Repricing', value: 50 }
    ]

    const selectedGraphData = [
        { name: 'Jan', Converted: 60, Picked: 50, NotConverted: 30 },
        { name: 'Feb', Converted: 40, Picked: 20, NotConverted: 80 },
        { name: 'Mar', Converted: 60, Picked: 60, NotConverted: 60 },
        { name: 'Apr', Converted: 50, Picked: 20, NotConverted: 50 },
        { name: 'May', Converted: 60, Picked: 50, NotConverted: 30 },
        { name: 'Jun', Converted: 40, Picked: 20, NotConverted: 80 },
        { name: 'Jul', Converted: 60, Picked: 60, NotConverted: 60 },
        { name: 'Aug', Converted: 50, Picked: 20, NotConverted: 50 },
        { name: 'Sep', Converted: 60, Picked: 50, NotConverted: 30 },
        { name: 'Oct', Converted: 40, Picked: 20, NotConverted: 80 },
        { name: 'Nov', Converted: 60, Picked: 60, NotConverted: 60 },
        { name: 'Dec', Converted: 50, Picked: 20, NotConverted: 50 },
    ];

    // Deals By Stage
    const airLeads = [
        { name: 'Air', value: 450 },
        { name: 'Ocean', value: 250 },
        { name: 'Courier', value: 400 },
    ];

    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <ul style={{ fontSize: '13px' }} className="d-flex justify-content-center gap-2 pb-2">
                {payload.map((entry, index) => {

                    let color;
                    if (entry.value === 'Converted') {
                        color = '#5cb85c';
                    } else if (entry.value === 'Picked') {
                        color = '#ffdc31';
                    } else if (entry.value === 'NotConverted') {
                        color = '#e41f07';
                    }

                    return (
                        <li key={`item-${index}`} style={{ color }}>
                            {entry.value}
                        </li>
                    );
                })}
            </ul>
        );
    };


    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#FF5A91', '#00FFAB', '#4F94D4', '#FF4500'];

    const chartRef = useRef(null)
    useEffect(() => {
        localStorage.setItem("menuOpened", "Dashboard")
    }, [])
    useEffect(() => {
        if (chartRef.current) {
            const options = {
                series: [
                    {
                        name: "sales",
                        colors: ["#FFC38F"],
                        data: [
                            {
                                x: "Inpipeline",
                                y: 400
                            },
                            {
                                x: "Follow Up",
                                y: 130
                            },
                            {
                                x: "Schedule",
                                y: 248
                            },
                            {
                                x: "Conversation",
                                y: 470
                            },
                            {
                                x: "Won",
                                y: 470
                            },
                            {
                                x: "Lost",
                                y: 180
                            }
                        ]
                    }
                ],
                chart: {
                    type: "bar",
                    height: 275
                },
                plotOptions: {
                    bar: {
                        borderRadiusApplication: "around",
                        columnWidth: "40%"
                    }
                },
                colors: ["#00918E"],
                xaxis: {
                    type: "category",
                    group: {
                        style: {
                            fontSize: "7px",
                            fontWeight: 700
                        }
                    }
                },
                yaxis: {
                    min: 0,
                    max: 500,
                    tickAmount: 5
                }
            }

            const chart = new ApexCharts(chartRef.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])

    //  Leads By Stage
    const LeadsBySatge = useRef(null)

    useEffect(() => {
        if (LeadsBySatge.current) {
            const options = {
                series: [
                    {
                        data: [400, 220, 448]
                    }
                ],
                chart: {
                    type: "bar",
                    height: 150
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#FC0027"],
                xaxis: {
                    categories: ["Conversation", "Follow Up", "Inpipeline"],
                    min: 0,
                    max: 500,
                    tickAmount: 5
                }
            }

            const chart = new ApexCharts(LeadsBySatge.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])
    // Won Deals Chat
    const wonChat = useRef(null)
    useEffect(() => {
        const options = {
            series: [
                {
                    data: [400, 122, 250]
                }
            ],
            chart: {
                type: "bar",
                height: 150
            },
            plotOptions: {
                bar: {
                    horizontal: true
                }
            },
            dataLabels: {
                enabled: false
            },
            colors: ["#5CB85C"],
            xaxis: {
                categories: ["Conversation", "Follow Up", "Inpipeline"],
                min: 0,
                max: 500,
                tickAmount: 5
            }
        }

        if (wonChat.current) {
            const chart = new ApexCharts(wonChat.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])
    // Deals By Year
    const dealsByYear = useRef(null)
    useEffect(() => {
        const options = {
            series: [
                {
                    name: "Deals",
                    data: [10, 20, 30, 15, 22, 40, 30, 20, 30, 18, 30, 60]
                }
            ],
            chart: {
                height: 273,
                type: "area",
                zoom: {
                    enabled: false
                }
            },
            colors: ["#E41F07"],
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: "straight"
            },
            title: {
                text: "",
                align: "left"
            },
            xaxis: {
                categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ]
            },
            yaxis: {
                min: 10,
                max: 60,
                tickAmount: 5,
                labels: {
                    formatter: val => {
                        return val / 1 + "K"
                    }
                }
            },
            legend: {
                position: "top",
                horizontalAlign: "left"
            }
        }

        if (dealsByYear.current) {
            const chart = new ApexCharts(dealsByYear.current, options)
            chart.render()

            // Cleanup on unmount
            return () => {
                chart.destroy()
            }
        }
    }, [])

    const initialSettings = {
        endDate: new Date("2020-08-11T12:30:00.000Z"),
        ranges: {
            "Last 30 Days": [
                new Date("2020-07-12T04:57:17.076Z"),
                new Date("2020-08-10T04:57:17.076Z")
            ],
            "Last 7 Days": [
                new Date("2020-08-04T04:57:17.076Z"),
                new Date("2020-08-10T04:57:17.076Z")
            ],
            "Last Month": [
                new Date("2020-06-30T18:30:00.000Z"),
                new Date("2020-07-31T18:29:59.999Z")
            ],
            "This Month": [
                new Date("2020-07-31T18:30:00.000Z"),
                new Date("2020-08-31T18:29:59.999Z")
            ],
            Today: [
                new Date("2020-08-10T04:57:17.076Z"),
                new Date("2020-08-10T04:57:17.076Z")
            ],
            Yesterday: [
                new Date("2020-08-09T04:57:17.076Z"),
                new Date("2020-08-09T04:57:17.076Z")
            ]
        },
        startDate: new Date("2020-08-04T04:57:17.076Z"), // Set "Last 7 Days" as default
        timePicker: false
    }
    const location = useLocation()
    const [showLoader, setShowLoader] = useState(false)

    useEffect(() => {
        if (location.pathname === "/flexichain/dashboard") {
            setShowLoader(true)
            setTimeout(() => {
                setShowLoader(false)
            }, 2000)
        }
    }, [location.pathname])

    const headerCollapse = useSelector(state => state.headerCollapse)

    // const toggleHeaderCollapse = () => {
    //   dispatch(setHeaderCollapse(!headerCollapse))
    // }



    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    {(CustomerProfileData && CustomerProfileData.profileCompleted && CustomerProfileData.approval == "DISAPPROVED") && <RejectionAlert reason={CustomerProfileData?.rejection_reason} />}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="page-header">
                                <div className="row align-items-center ">
                                    <div className="col-md-4">
                                        <h3 className="page-title">Customer Dashboard</h3>
                                    </div>
                                    <div className="col-md-8 float-end ms-auto">
                                        <div className="d-flex title-head">
                                            <div className="daterange-picker d-flex align-items-center justify-content-center">
                                                {/* <div className="form-sort me-2">
                                                    <i className="ti ti-calendar" />
                                                    <DateRangePicker initialSettings={initialSettings}>
                                                        <input
                                                            className="form-control bookingrange"
                                                            type="text"
                                                        />
                                                    </DateRangePicker>
                                                </div> */}
                                                <div className="head-icons mb-0">
                                                    {/* <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={<Tooltip id="refresh-tooltip">Refresh</Tooltip>}
                                                    >
                                                        <Link to="#">
                                                            <i className="ti ti-refresh-dot" />
                                                        </Link>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={<Tooltip id="collapse-tooltip">Collapse</Tooltip>}
                                                    >
                                                        <Link to="#" id="collapse-header">
                                                            <i className="ti ti-chevrons-up" />
                                                        </Link>
                                                    </OverlayTrigger> */}

                                                    {/* <select className="form-select" name="year" id="yearDropdown" onChange={handleYearChange} value={currentYear}>
                                                        {years.map(year => (
                                                            <option key={year} value={year}>{year}</option>
                                                        ))}
                                                    </select> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Total Orders
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        1200{/* {AdminDashboardCounter?.data?.customerCount} */}
                                    </span>
                                    <svg width="41" height="30" viewBox="0 0 41 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20.0732 19.3232C13.7482 19.3232 8.4115 20.3568 8.4115 24.3456C8.4115 28.3362 13.7827 29.3334 20.0732 29.3334C26.3982 29.3334 31.7349 28.2998 31.7349 24.311C31.7349 20.3205 26.3637 19.3232 20.0732 19.3232"
                                            fill="#000000" />
                                        <path opacity="0.4"
                                            d="M20.0732 15.5229C24.3561 15.5229 27.7903 12.069 27.7903 7.76144C27.7903 3.45228 24.3561 0 20.0732 0C15.7904 0 12.3562 3.45228 12.3562 7.76144C12.3562 12.069 15.7904 15.5229 20.0732 15.5229"
                                            fill="#000000" />
                                        <path opacity="0.4"
                                            d="M36.8279 9.56867C37.936 5.20998 34.6873 1.29541 30.5505 1.29541C30.1007 1.29541 29.6707 1.34494 29.2504 1.42914C29.1946 1.44235 29.1322 1.47042 29.0994 1.51995C29.0616 1.58269 29.0895 1.66689 29.1306 1.72137C30.3732 3.47476 31.0873 5.60952 31.0873 7.90114C31.0873 10.097 30.4323 12.1443 29.2832 13.8432C29.1651 14.0182 29.2701 14.2543 29.4786 14.2906C29.7675 14.3418 30.063 14.3682 30.365 14.3764C33.3773 14.4557 36.081 12.5058 36.8279 9.56867"
                                            fill="#000000" />
                                        <path
                                            d="M39.9837 19.8308C39.4321 18.6487 38.1008 17.8381 36.0768 17.4402C35.1214 17.2057 32.5359 16.8755 30.131 16.9201C30.0949 16.9251 30.0752 16.9498 30.0719 16.9663C30.067 16.9894 30.0768 17.0291 30.1244 17.0538C31.2358 17.6069 35.5317 20.0125 34.9917 25.086C34.9687 25.3056 35.1443 25.4955 35.3627 25.4625C36.4198 25.3106 39.1399 24.7228 39.9837 22.8918C40.4499 21.9243 40.4499 20.8 39.9837 19.8308"
                                            fill="#000000" />
                                        <path opacity="0.4"
                                            d="M11.0822 1.42963C10.6636 1.34378 10.2318 1.2959 9.78206 1.2959C5.6453 1.2959 2.39663 5.21047 3.50633 9.56916C4.2516 12.5063 6.95527 14.4562 9.96755 14.3769C10.2696 14.3687 10.5667 14.3406 10.854 14.2911C11.0625 14.2548 11.1675 14.0187 11.0494 13.8436C9.90025 12.1431 9.24526 10.0975 9.24526 7.90163C9.24526 5.60836 9.96099 3.47359 11.2037 1.72186C11.2431 1.66738 11.2726 1.58318 11.2332 1.52044C11.2004 1.46926 11.1396 1.44284 11.0822 1.42963"
                                            fill="#000000" />
                                        <path
                                            d="M4.25618 17.4398C2.23213 17.8377 0.902454 18.6483 0.350886 19.8305C-0.116962 20.7996 -0.116962 21.924 0.350886 22.8931C1.19465 24.7224 3.91474 25.3118 4.97191 25.4621C5.19024 25.4951 5.36425 25.3069 5.34126 25.0857C4.80119 20.0137 9.09718 17.6082 10.2102 17.0551C10.2561 17.0287 10.266 16.9907 10.2611 16.9659C10.2578 16.9494 10.2397 16.9247 10.2036 16.9214C7.79706 16.8751 5.21322 17.2053 4.25618 17.4398"
                                            fill="#000000" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Total Quotation
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        1200
                                    </span>
                                    <svg width="41" height="30" viewBox="0 0 41 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20.0732 19.3232C13.7482 19.3232 8.4115 20.3568 8.4115 24.3456C8.4115 28.3362 13.7827 29.3334 20.0732 29.3334C26.3982 29.3334 31.7349 28.2998 31.7349 24.311C31.7349 20.3205 26.3637 19.3232 20.0732 19.3232"
                                            fill="#000000" />
                                        <path opacity="0.4"
                                            d="M20.0732 15.5229C24.3561 15.5229 27.7903 12.069 27.7903 7.76144C27.7903 3.45228 24.3561 0 20.0732 0C15.7904 0 12.3562 3.45228 12.3562 7.76144C12.3562 12.069 15.7904 15.5229 20.0732 15.5229"
                                            fill="#000000" />
                                        <path opacity="0.4"
                                            d="M36.8279 9.56867C37.936 5.20998 34.6873 1.29541 30.5505 1.29541C30.1007 1.29541 29.6707 1.34494 29.2504 1.42914C29.1946 1.44235 29.1322 1.47042 29.0994 1.51995C29.0616 1.58269 29.0895 1.66689 29.1306 1.72137C30.3732 3.47476 31.0873 5.60952 31.0873 7.90114C31.0873 10.097 30.4323 12.1443 29.2832 13.8432C29.1651 14.0182 29.2701 14.2543 29.4786 14.2906C29.7675 14.3418 30.063 14.3682 30.365 14.3764C33.3773 14.4557 36.081 12.5058 36.8279 9.56867"
                                            fill="#000000" />
                                        <path
                                            d="M39.9837 19.8308C39.4321 18.6487 38.1008 17.8381 36.0768 17.4402C35.1214 17.2057 32.5359 16.8755 30.131 16.9201C30.0949 16.9251 30.0752 16.9498 30.0719 16.9663C30.067 16.9894 30.0768 17.0291 30.1244 17.0538C31.2358 17.6069 35.5317 20.0125 34.9917 25.086C34.9687 25.3056 35.1443 25.4955 35.3627 25.4625C36.4198 25.3106 39.1399 24.7228 39.9837 22.8918C40.4499 21.9243 40.4499 20.8 39.9837 19.8308"
                                            fill="#000000" />
                                        <path opacity="0.4"
                                            d="M11.0822 1.42963C10.6636 1.34378 10.2318 1.2959 9.78206 1.2959C5.6453 1.2959 2.39663 5.21047 3.50633 9.56916C4.2516 12.5063 6.95527 14.4562 9.96755 14.3769C10.2696 14.3687 10.5667 14.3406 10.854 14.2911C11.0625 14.2548 11.1675 14.0187 11.0494 13.8436C9.90025 12.1431 9.24526 10.0975 9.24526 7.90163C9.24526 5.60836 9.96099 3.47359 11.2037 1.72186C11.2431 1.66738 11.2726 1.58318 11.2332 1.52044C11.2004 1.46926 11.1396 1.44284 11.0822 1.42963"
                                            fill="#000000" />
                                        <path
                                            d="M4.25618 17.4398C2.23213 17.8377 0.902454 18.6483 0.350886 19.8305C-0.116962 20.7996 -0.116962 21.924 0.350886 22.8931C1.19465 24.7224 3.91474 25.3118 4.97191 25.4621C5.19024 25.4951 5.36425 25.3069 5.34126 25.0857C4.80119 20.0137 9.09718 17.6082 10.2102 17.0551C10.2561 17.0287 10.266 16.9907 10.2611 16.9659C10.2578 16.9494 10.2397 16.9247 10.2036 16.9214C7.79706 16.8751 5.21322 17.2053 4.25618 17.4398"
                                            fill="#000000" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Completed Orders
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        120  {/* {AdminDashboardCounter?.data?.leadCount} */}
                                    </span>
                                    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M21.4683 4.83296C21.4683 8.3499 24.3235 11.2009 27.8456 11.2009C28.2334 11.199 28.6202 11.1618 29.0013 11.0897V23.7144C29.0013 29.0257 25.8683 32.168 20.5493 32.168H8.96428C3.63129 32.168 0.498337 29.0257 0.498337 23.7144V12.1464C0.498337 6.83512 3.63129 3.66504 8.96428 3.66504H21.5796C21.5048 4.04984 21.4675 4.44098 21.4683 4.83296ZM18.1543 20.9197L22.6797 15.0801V15.0523C23.0671 14.5317 22.9682 13.7977 22.4569 13.3978C22.2094 13.2067 21.8949 13.124 21.5852 13.1685C21.2756 13.2131 20.9972 13.3811 20.8138 13.6341L16.9986 18.5422L12.6542 15.1218C12.4062 14.9286 12.0906 14.8433 11.7789 14.8851C11.4671 14.927 11.1853 15.0925 10.9972 15.3443L6.31867 21.3786C6.15422 21.5836 6.06569 21.8389 6.06804 22.1016C6.04088 22.6324 6.37607 23.1145 6.88359 23.2748C7.39111 23.435 7.94295 23.2328 8.22629 22.7829L12.139 17.7219L16.4834 21.1283C16.7305 21.3275 17.0481 21.4178 17.3632 21.3785C17.6783 21.3392 17.9639 21.1736 18.1543 20.9197Z"
                                            fill="#000000" />
                                        <ellipse opacity="0.4" cx="28.2095" cy="4.45679" rx="3.95874" ry="3.95874" fill="#646464" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 ">
                            <div className="card flex-fill stat-cards-admin">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 className="mb-0">
                                            Orders In Process
                                        </h4>
                                    </div>
                                </div>
                                <div className="card-body d-flex justify-content-between align-items-center">
                                    <span className="">
                                        1200{/* {AdminDashboardCounter?.data?.pricingCount} */}
                                    </span>
                                    <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" clipRule="evenodd"
                                            d="M4.24944 1.4165C2.68482 1.4165 1.41644 2.6849 1.41644 4.2495V24.0805C1.41644 25.6451 2.68482 26.9135 4.24944 26.9135H24.0804C25.6451 26.9135 26.9134 25.6451 26.9134 24.0805V4.2495C26.9134 2.6849 25.6451 1.4165 24.0804 1.4165H4.24944ZM8.49894 15.5815C8.49894 14.7992 7.86475 14.165 7.08244 14.165C6.30013 14.165 5.66594 14.7992 5.66594 15.5815V21.2475C5.66594 22.0298 6.30013 22.664 7.08244 22.664C7.86475 22.664 8.49894 22.0298 8.49894 21.2475V15.5815ZM14.1649 9.9155C14.9473 9.9155 15.5814 10.5497 15.5814 11.332V21.2475C15.5814 22.0298 14.9473 22.664 14.1649 22.664C13.3826 22.664 12.7484 22.0298 12.7484 21.2475V11.332C12.7484 10.5497 13.3826 9.9155 14.1649 9.9155ZM22.6639 7.0825C22.6639 6.30016 22.0298 5.666 21.2474 5.666C20.4651 5.666 19.8309 6.30016 19.8309 7.0825V21.2475C19.8309 22.0298 20.4651 22.664 21.2474 22.664C22.0298 22.664 22.6639 22.0298 22.6639 21.2475V7.0825Z"
                                            fill="#000000" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            All Orders
                                        </h4>
                                        <div className="dropdown">
                                            <select className="form-select" name="dropdown" id="graphDropdown"
                                            // onChange={handleGraphDropdownChange} value={dropdownValue}
                                            >
                                                {/* {DashboardGraphDropdownData?.map(option => (
                                                    <option key={option} value={option}>{option}</option>
                                                ))} */}
                                                <option value="">All</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                {/* <LineChart
                                    xAxis={[{ data: [1, 2, 3, 5, 8, 10] }]}
                                    series={[
                                        {
                                            data: [2, 5.5, 2, 8.5, 1.5, 5],
                                            area: true,
                                        },
                                    ]}
                                    width="100%"
                                    height={300}
                                /> */}
                                {/* <ResponsiveContainer width="100%" height={300}>
                                    <LineChart
                                        data={data}
                                        margin={{
                                            top: 20, right: 30, left: 20, bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis style={{ fontSize: '12px' }} dataKey="name" />
                                        <YAxis style={{ fontSize: '12px' }} />
                                        <Tooltip />
                                        <Legend />
                                        <Line type="monotone" dataKey="Converted" stroke="#008500"  activeDot={{ r: 8 }} />
                                        <Line type="monotone" dataKey="Picked" stroke="#efff00" />
                                        <Line type="monotone" dataKey="NotConverted" stroke="#ff0000" />
                                    </LineChart>
                                </ResponsiveContainer> */}
                                <ResponsiveContainer width="100%" height={250}>
                                    <AreaChart width="100%" height={250} data={selectedGraphData}
                                        margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                                        <defs>
                                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#82ca9d" stopOpacity={0} />
                                            </linearGradient>
                                            <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#f2ff33c9" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#f2ff33c9" stopOpacity={0} />
                                            </linearGradient>
                                            <linearGradient id="colorNv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="5%" stopColor="#f62f2cbf" stopOpacity={0.8} />
                                                <stop offset="95%" stopColor="#f62f2cbf" stopOpacity={0} />
                                            </linearGradient>
                                        </defs>
                                        <XAxis dataKey="name" style={{ fontSize: '10px' }} />
                                        <YAxis style={{ fontSize: '10px' }} />
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <Tooltip />
                                        <Legend content={renderLegend} />
                                        <Area type="monotone" dataKey="Converted" stroke="#82ca9d" fillOpacity={1} fill="url(#colorUv)" />
                                        <Area type="monotone" dataKey="Picked" stroke="#f2ff33c9" fillOpacity={1} fill="url(#colorPv)" />
                                        <Area type="monotone" dataKey="NotConverted" stroke="#f62f2cbf" fillOpacity={1} fill="url(#colorNv)" />
                                    </AreaChart>
                                </ResponsiveContainer>

                                {/* <ResponsiveContainer width="100%" height={300}>
                                    <LineChart
                                        data={data}
                                        margin={{
                                            top: 20, right: 30, left: 20, bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis style={{ fontSize: '12px' }} dataKey="name" />
                                        <YAxis style={{ fontSize: '12px' }} />
                                        <Tooltip />
                                        <Legend />
                                        <Line type="monotone" dataKey="Converted" stroke="#008500" activeDot={{ r: 8 }} />
                                        <Line type="monotone" dataKey="Picked" stroke="#efff00" />
                                        <Line type="monotone" dataKey="NotConverted" stroke="#ff0000" />
                                    </LineChart>
                                </ResponsiveContainer> */}
                            </div>

                        </div>
                        <div className="col-md-6">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Total Quotation
                                        </h4>
                                        <div className="dropdown">
                                            <select className="form-select" name="dropdown" id="graphDropdown"
                                            // onChange={handleSecondGraphDropdownChange} value={seconddropdownValue}
                                            >
                                                {/* {DashboardSecondGraphDropdownData?.map(option => (
                                                    <option key={option} value={option}>{option}</option>
                                                ))} */}
                                                <option value="">All</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <ResponsiveContainer width="100%" height={250}>
                                    <BarChart data={selectedsecondGraphData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis style={{ fontSize: '10px' }} dataKey="name" interval={0} angle={-30} textAnchor="end" />
                                        <YAxis style={{ fontSize: '10px' }} />
                                        <Tooltip />
                                        <Bar dataKey="value" fill="#26a19f" barSize={20} >
                                            <LabelList dataKey="value" position="top" style={{ fontSize: '12px' }} />
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Recently Created Leads
                                        </h4>
                                        {/* <div className="dropdown">
                                            <Link
                                                className="dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                to="#"
                                            >
                                                <i className="ti ti-calendar-check me-2" />
                                                Last 30 days
                                            </Link>
                                            <div className="dropdown-menu dropdown-menu-end">
                                                <Link to="#" className="dropdown-item">
                                                    Last 15 days
                                                </Link>
                                                <Link to="#" className="dropdown-item">
                                                    Last 30 days
                                                </Link>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive custom-table">
                                        <table className="table dataTable" >

                                            <table><thead className="thead-light">
                                                <tr>
                                                    <th>Request No.</th>
                                                    <th>Date</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Phone Number</th>
                                                    <th>Origin</th>
                                                    <th>Destination</th>
                                                    <th>Shipment Mode</th>

                                                </tr>
                                            </thead><tbody>
                                                    {/* {AdminDashboardCounter?.data?.recentLeads?.length > 0 ?
                                                        <>
                                                            {AdminDashboardCounter?.data?.recentLeads?.map((values) => (


                                                                <tr className="odd">
                                                                    <td>{values?.request_no ? values?.request_no : 'N/A'}</td>
                                                                    <td>{values?.createdAt ? new Date(values?.createdAt).toLocaleDateString() : 'N/A'}</td>
                                                                    <td>{values?.full_name ? values.full_name : 'N/A'}</td>
                                                                    <td>{values?.email ? values?.email : 'N/A'}</td>
                                                                    <td>{values?.phone ? values?.phone : 'N/A'}</td>
                                                                    <td>{values?.origin_address ? values?.origin_address : 'N/A'}</td>
                                                                    <td>{values?.destination_address ? values?.destination_address : 'N/A'}</td>
                                                                    <td>{values?.shipment_mode ? values?.shipment_mode : 'N/A'}</td>
                                                                   
           
                                                                </tr>
                                                            ))}
                                                        </>
                                                        :
                                                        <p>No Data</p>
                                                    } */}
                                                    <tr className="odd">
                                                        <td>098764</td>
                                                        <td>06-09-2024</td>
                                                        <td>John Doe</td>
                                                        <td>john@gmail.com</td>
                                                        <td>9875356677</td>
                                                        <td>Delhi</td>
                                                        <td>Kolkata</td>
                                                        <td>Air</td>


                                                    </tr>
                                                    <tr className="odd">
                                                        <td>098764</td>
                                                        <td>06-09-2024</td>
                                                        <td>John Doe</td>
                                                        <td>john@gmail.com</td>
                                                        <td>9875356677</td>
                                                        <td>Delhi</td>
                                                        <td>Kolkata</td>
                                                        <td>Air</td>


                                                    </tr>
                                                    <tr className="odd">
                                                        <td>098764</td>
                                                        <td>06-09-2024</td>
                                                        <td>John Doe</td>
                                                        <td>john@gmail.com</td>
                                                        <td>9875356677</td>
                                                        <td>Delhi</td>
                                                        <td>Kolkata</td>
                                                        <td>Air</td>


                                                    </tr>
                                                    <tr className="odd">
                                                        <td>098764</td>
                                                        <td>06-09-2024</td>
                                                        <td>John Doe</td>
                                                        <td>john@gmail.com</td>
                                                        <td>9875356677</td>
                                                        <td>Delhi</td>
                                                        <td>Kolkata</td>
                                                        <td>Air</td>


                                                    </tr>
                                                </tbody></table>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Pricing Leads
                                        </h4>
                                        {/* <div className="dropdown">
                                            <select className="form-select" name="year" id="yearDropdown" onChange={(e) => { handleYearChange(e) }}>
                                                {years.map(year => (
                                                    <option key={year} value={year}>{year}</option>
                                                ))}
                                            </select>
                                        </div> */}
                                    </div>
                                </div>
                                {/* <ResponsiveContainer width="100%" height={250}>
                                    <BarChart data={PricingData} margin={{ top: 20, right: 30, left: 20, bottom: 60 }}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis style={{ fontSize: '10px' }} dataKey="name" interval={0} angle={-30} textAnchor="end" />
                                        <YAxis style={{ fontSize: '10px' }} />
                                        <Tooltip />
                                        <Bar dataKey="value" fill="#26a19f" barSize={20} >
                                            <LabelList dataKey="value" position="top" style={{ fontSize: '12px' }} />
                                        </Bar>
                                    </BarChart>
                                </ResponsiveContainer> */}
                                <ResponsiveContainer width="100%" height={300}>
                                    <PieChart>
                                        <Pie
                                            data={PricingData}
                                            dataKey="value"
                                            nameKey="name"
                                            cx="50%"  // Center X position
                                            cy="50%"  // Center Y position
                                            outerRadius={100} // Size of the pie
                                            fill="#8884d8"
                                            label
                                        >
                                            {PricingData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip />
                                        <Legend />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                        {/* <div className="col-md-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4>
                                            <i className="ti ti-grip-vertical me-1" />
                                            Deals By Stage
                                        </h4>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="dropdown me-2">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Sales Pipeline
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Marketing Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Sales Pipeline
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Email
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Chats
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Operational
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="dropdown">
                                                <Link
                                                    className="dropdown-toggle"
                                                    data-bs-toggle="dropdown"
                                                    to="#"
                                                >
                                                    Last 30 Days
                                                </Link>
                                                <div className="dropdown-menu dropdown-menu-end">
                                                    <Link to="#" className="dropdown-item">
                                                        Last 30 Days
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 15 Days
                                                    </Link>
                                                    <Link to="#" className="dropdown-item">
                                                        Last 7 Days
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div ref={chartRef} />
                                </div>
                            </div>
                        </div> */}
                    </div>




                </div>
            </div>
        </>
    )
}

export default CustomerDashboardPage
